var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav flex-column p-3"},_vm._l((_vm.routes),function(r,i){return _c('menu-item',{key:i,attrs:{"route":r}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }